'use strict';

import angular from 'angular';
import moment from 'moment';
import * as Datetime from './datetime.js';

export default angular.module('georgeApp.datetime', [])
  .constant('moment', moment)
  .filter('dateToString', Datetime.dateToStringFilter)
  .filter('rangeToString', Datetime.rangeToStringFilter)
  .factory('DatetimeSvc', Datetime.DatetimeSvc)
  .name;
